import axiosInstance from "./axiosInstance";

const PROFILE_USERS_BASE_URL = "/profile/users";
const PROFILE_USER_BASE_URL = "/profile/user";
const PROFILE_UPDATE_BASE_URL = "/profile/update";
const ACTIVATE_USER_BASE_URL = "profile/activate";
const DEACTIVATE_USER_BASE_URL = "profile/deactivate";
const PROFILE_MERCHANT_USERS_BASE_URL = "/profile/merchant/users";

const profileService = {
  getCurrentUser: async () => {
    const response = await axiosInstance.get(PROFILE_USER_BASE_URL);
    return response.data;
  },

  getAllUsers: async () => {
    const response = await axiosInstance.get(PROFILE_USERS_BASE_URL);
    return response.data;
  },

  getAllMerchantUsers: async () => {
    const response = await axiosInstance.get(PROFILE_MERCHANT_USERS_BASE_URL);
    return response.data;
  },

  createMerchantProfile: async (userData) => {
    const response = await axiosInstance.post(
      PROFILE_MERCHANT_USERS_BASE_URL,
      userData,
    );
    return response.data;
  },

  getUserById: async (userId) => {
    const response = await axiosInstance.get(
      `${PROFILE_USER_BASE_URL}/${userId}`,
    );
    return response.data;
  },

  updateUser: async (userId, userData) => {
    const response = await axiosInstance.put(
      `${PROFILE_UPDATE_BASE_URL}/${userId}`,
      userData,
    );
    return response.data;
  },

  activateUser: async (userId) => {
    const response = await axiosInstance.get(
      `${ACTIVATE_USER_BASE_URL}/${userId}`,
    );
    return response.data;
  },

  deactivateUser: async (userId) => {
    const response = await axiosInstance.get(
      `${DEACTIVATE_USER_BASE_URL}/${userId}`,
    );
    return response.data;
  },
};

export default profileService;
